import React from 'react'
import { View, Text, Image, StyleSheet, Dimensions } from 'react-native'
import PropTypes from 'prop-types'
import { isPortrait } from '../orientation' 

const s3URL = 'https://ecomseating.s3.amazonaws.com/images/build-a-chair/120x120/'

type QuestionImageProps = {
  /** The name of the color image. */
  name: string,
  /** The image to dispaly. */
  image: string,
}

/**
 * An image to display next to the question's answer.
 * @component
 */
export const QuestionImage = ({name, image}: QuestionImageProps) => (
  <View style={isPortrait() ? styles.mobileContainer : styles.desktopContainer}>
    <Image style={{width: 60, height: 60}} source={{uri: s3URL + image}} />
    <Text style={isPortrait() ? styles.mobileText : styles.desktopText}>
      {name}  
    </Text>
  </View>
)

QuestionImage.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
}

const styles = StyleSheet.create({
  mobileContainer: {
    marginLeft: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  desktopContainer: {
    marginLeft: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileText: {
    fontSize: 16,
    marginTop: 30,
    marginBottom: 30,
    marginLeft: 10,
    color: '#333',
    fontWeight: 'bold',
    maxWidth: 140,
  },
  desktopText: {
    marginLeft: 30,
    fontSize: 16,
    marginTop: 30,
    marginBottom: 30,
    color: '#333',
    fontWeight: 'bold',
    maxWidth: 160,
  }
})
